import api from './api';

export function insereFaleConosco({
  Nome,
  Matricula,
  Email,
  Telefone,
  Celular,
  Assunto,
  Mensagem,
  Protocolo,
  token,
}) {
  return api.post('insereFaleConosco', {
    Nome,
    Matricula,
    Email,
    Telefone,
    Celular,
    Assunto,
    Mensagem,
    Protocolo,
    Origem: 'FALECONOSCO',
    token,
  });
}
